import { service } from '@ember/service';
import Component from '@glimmer/component';

export default class ChatRoadmapRendererComponent extends Component {
  @service store;

  get roadmap() {
    if (this.args.roadmap_id)
      return this.store.peekRecord('roadmap', this.args.roadmap_id);
    else return null;
  }
}
